export enum BPRegistrationTranslationCodes {
  step1_alr_linked = 'bpRegistration:step1_alr_linked',
  step1_cl_reg = 'bpRegistration:step1_cl_reg',
  step1_cont_reg = 'bpRegistration:step1_cont_reg',
  language = 'bpRegistration:language',
  email_address = 'bpRegistration:email_address',
  country_of_business = 'bpRegistration:country_of_business',
  mobile_phone_number = 'bpRegistration:mobile_phone_number',
  step1_header = 'bpRegistration:step1_header',
  step1_info1 = 'bpRegistration:step1_info1',
  step1_info2 = 'bpRegistration:step1_info2',
  step1_info3_1 = 'bpRegistration:step1_info3_1',
  step1_details = 'bpRegistration:step1_details',
  thanks = 'bpRegistration:thanks',
  step1_invitation = 'bpRegistration:step1_invitation',
  step2_form_text = 'bpRegistration:step2_form_text',
  step2_allowed = 'bpRegistration:step2_allowed',
  step2_support = 'bpRegistration:step2_support',
  company = 'bpRegistration:company',
  partner_id = 'bpRegistration:partner_id',
  enrollment_id = 'bpRegistration:enrollment_id',
  onb_overall_progress = 'bpRegistration:onb_overall_progress',
  company_name = 'bpRegistration:company_name',
  city = 'bpRegistration:city',
  country = 'bpRegistration:country',
  vat_id = 'bpRegistration:vat_id',
  search = 'bpRegistration:search',
  none_of_the_above = 'bpRegistration:none_of_the_above',
  step2_text1 = 'bpRegistration:step2_text1',
  step2_text2 = 'bpRegistration:step2_text2',
  step2_text3 = 'bpRegistration:step2_text3',
  step2_yesbtn = 'bpRegistration:step2_yesbtn',
  step2_nobtn = 'bpRegistration:step2_nobtn',
  step2_details = 'bpRegistration:step2_details',
  reselect_company = 'bpRegistration:reselect_company',
  address1 = 'bpRegistration:address1',
  address3 = 'bpRegistration:address3',
  incorrect_phone_number = 'bpRegistration:incorrect_phone_number',
  phone = 'bpRegistration:phone',
  address2 = 'bpRegistration:address2',
  postal_code = 'bpRegistration:postal_code',
  company_website = 'bpRegistration:company_website',
  email_validation = 'bpRegistration:email_validation',
  email_validation_status = 'bpRegistration:email_validation_status',
  section_is_not_needed = 'bpRegistration:section_is_not_needed',
  company_data = 'bpRegistration:company_data',
  company_data_status = 'bpRegistration:company_data_status',
  contact_data = 'bpRegistration:contact_data',
  contact_data_status = 'bpRegistration:contact_data_status',
  step3_contact_info = 'bpRegistration:step3_contact_info',
  user_details = 'bpRegistration:user_details',
  first_name = 'bpRegistration:first_name',
  last_name = 'bpRegistration:last_name',
  job_role = 'bpRegistration:job_role',
  job_level = 'bpRegistration:job_level',
  work_phone_number = 'bpRegistration:work_phone_number',
  cont_perm_text = 'bpRegistration:cont_perm_text',
  yes = 'bpRegistration:yes',
  no = 'bpRegistration:no',
  general_manager_details = 'bpRegistration:general_manager_details',
  gen_manager_info_text = 'bpRegistration:gen_manager_info_text',
  job_title = 'bpRegistration:job_title',
  job_function = 'bpRegistration:job_function',
  terms_and_conditions = 'bpRegistration:terms_and_conditions',
  terms_and_conditions_status = 'bpRegistration:terms_and_conditions_status',
  step4_header1 = 'bpRegistration:step4_header1',
  step4_header2 = 'bpRegistration:step4_header2',
  step4_awareness = 'bpRegistration:step4_awareness',
  empty_text = 'bpRegistration:empty_text',
  step4_check = 'bpRegistration:step4_check',
  step4_confimation = 'bpRegistration:step4_confimation',
  shouldnt_be_empty = 'bpRegistration:shouldnt_be_empty',
  continue = 'bpRegistration:continue',
  company_details = 'bpRegistration:company_details',
  company_details_status = 'bpRegistration:company_details_status',
  business_survey = 'bpRegistration:business_survey',
  step5_profile = 'bpRegistration:step5_profile',
  channel_business_model = 'bpRegistration:channel_business_model',
  step5_showroom = 'bpRegistration:step5_showroom',
  step5_vert_markets = 'bpRegistration:step5_vert_markets',
  step5_share_wallet = 'bpRegistration:step5_share_wallet',
  step5_input_share = 'bpRegistration:step5_input_share',
  step5_cust_type = 'bpRegistration:step5_cust_type',
  step5_mix = 'bpRegistration:step5_mix',
  step5_cont = 'bpRegistration:step5_cont',
  cust_type_accounts = 'bpRegistration:cust_type_accounts',
  cust_type_bs_large = 'bpRegistration:cust_type_bs_large',
  cust_type_small_business = 'bpRegistration:cust_type_small_business',
  cust_type_bs_small = 'bpRegistration:cust_type_bs_small',
  cust_type_education = 'bpRegistration:cust_type_education',
  cust_type_bs_education = 'bpRegistration:cust_type_bs_education',
  cust_type_mid_market = 'bpRegistration:cust_type_mid_market',
  cust_type_bs_mid_market = 'bpRegistration:cust_type_bs_mid_market',
  cust_type_public = 'bpRegistration:cust_type_public',
  cust_type_bs_public = 'bpRegistration:cust_type_bs_public',
  cust_type_mass = 'bpRegistration:cust_type_mass',
  cust_type_bs_mas_market = 'bpRegistration:cust_type_bs_mas_market',
  cust_type_progress = 'bpRegistration:cust_type_progress',
  cust_type_progress_type = 'bpRegistration:cust_type_progress_type',
  cust_type_completeness = 'bpRegistration:cust_type_completeness',
  total_rev_hardware_pc = 'bpRegistration:total_rev_hardware_pc',
  total_rev_bs_hardware = 'bpRegistration:total_rev_bs_hardware',
  total_rev_service = 'bpRegistration:total_rev_service',
  total_rev_bs_service = 'bpRegistration:total_rev_bs_service',
  total_rev_other = 'bpRegistration:total_rev_other',
  total_rev_bs_other = 'bpRegistration:total_rev_bs_other',
  total_rev_hardware_print = 'bpRegistration:total_rev_hardware_print',
  total_rev_bs_hardware_print = 'bpRegistration:total_rev_bs_hardware_print',
  total_rev_software = 'bpRegistration:total_rev_software',
  total_rev_bs_software = 'bpRegistration:total_rev_bs_software',
  total_rev_ink_toner = 'bpRegistration:total_rev_ink_toner',
  total_rev_bs_toner = 'bpRegistration:total_rev_bs_toner',
  total_rev_progress = 'bpRegistration:total_rev_progress',
  total_rev_progress_rev = 'bpRegistration:total_rev_progress_rev',
  total_rev_completeness = 'bpRegistration:total_rev_completeness',
  cur_distr = 'bpRegistration:cur_distr',
  cur_distr_bs = 'bpRegistration:cur_distr_bs',
  cur_distr_vendors = 'bpRegistration:cur_distr_vendors',
  cur_distr_bs_vendors = 'bpRegistration:cur_distr_bs_vendors',
  main_no_access = 'bpRegistration:main_no_access',
  reg_was_removed = 'bpRegistration:reg_was_removed',
  end_partner = 'bpRegistration:end_partner',
  end_thanks = 'bpRegistration:end_thanks',
  end_hp_bp = 'bpRegistration:end_hp_bp',
  end_text = 'bpRegistration:end_text',
  regect_text1 = 'bpRegistration:regect_text1',
  regect_text2 = 'bpRegistration:regect_text2',
  regect_reason = 'bpRegistration:regect_reason',
  regect_cannot_cont = 'bpRegistration:regect_cannot_cont',
  reg_exists = 'bpRegistration:reg_exists',
  value_added_resseller = 'bpRegistration:value_added_resseller',
  value_added_resseller_desc = 'bpRegistration:value_added_resseller_desc',
  traditional_dealer = 'bpRegistration:traditional_dealer',
  traditional_dealer_desc = 'bpRegistration:traditional_dealer_desc',
  system_integrator = 'bpRegistration:system_integrator',
  system_integrator_desc = 'bpRegistration:system_integrator_desc',
  ind_software_vendor = 'bpRegistration:ind_software_vendor',
  ind_software_vendor_desc = 'bpRegistration:ind_software_vendor_desc',
  eseller_commercial = 'bpRegistration:eseller_commercial',
  eseller_commercial_desc = 'bpRegistration:eseller_commercial_desc',
  refiller = 'bpRegistration:refiller',
  refiller_desc = 'bpRegistration:refiller_desc',
  contact_stationer = 'bpRegistration:contact_stationer',
  contact_stationer_desc = 'bpRegistration:contact_stationer_desc',
  bank_securities_ins = 'bpRegistration:bank_securities_ins',
  commun_media_services = 'bpRegistration:commun_media_services',
  education = 'bpRegistration:education',
  covernment_public_admin = 'bpRegistration:covernment_public_admin',
  nat_resources_util = 'bpRegistration:nat_resources_util',
  health_providers = 'bpRegistration:health_providers',
  manufacturing = 'bpRegistration:manufacturing',
  ret_wholesale_trade = 'bpRegistration:ret_wholesale_trade',
  transportation = 'bpRegistration:transportation',
  sales = 'bpRegistration:sales',
  technical = 'bpRegistration:technical',
  marketing = 'bpRegistration:marketing',
  admin_and_finance = 'bpRegistration:admin_and_finance',
  admin = 'bpRegistration:admin',
  finance = 'bpRegistration:finance',
  purchasing = 'bpRegistration:purchasing',
  logistics_warehouse = 'bpRegistration:logistics_warehouse',
  logistics = 'bpRegistration:logistics',
  low_management = 'bpRegistration:low_management',
  staff = 'bpRegistration:staff',
  mid_management = 'bpRegistration:mid_management',
  exevutive_management = 'bpRegistration:exevutive_management',
  c_level = 'bpRegistration:c_level',
  coverage_city = 'bpRegistration:coverage_city',
  coverage_region = 'bpRegistration:coverage_region',
  coverage_country = 'bpRegistration:coverage_country',
  coverage_international = 'bpRegistration:coverage_international',
  end_req_id = 'bpRegistration:end_req_id',
  step4_time = 'bpRegistration:step4_time',
  step2_support1 = 'bpRegistration:step2_support1',
  gen_manager = 'bpRegistration:gen_manager',
  fixed_number = 'bpRegistration:fixed_number',
  corporate_email = 'bpRegistration:corporate_email',
  t_and_c_check_rules = 'bpRegistration:t_and_c_check_rules',
  phone_editor_code = 'bpRegistration:phone_editor_code',
  info_mod_empl_number = 'bpRegistration:info_mod_empl_number',
  info_mod_totalrev = 'bpRegistration:info_mod_totalrev',
  info_mod_terr_cov = 'bpRegistration:info_mod_terr_cov',
  email = 'bpRegistration:email',
  vert_market_primary = 'bpRegistration:vert_market_primary',
  vert_market_sec = 'bpRegistration:vert_market_sec',
  regect_text = 'bpRegistration:regect_text',
  regect_check_email = 'bpRegistration:regect_check_email',
  reg_over_attempts_search_counts = 'bpRegistration:reg_over_attempts_search_counts',
  resend_invite = 'bpRegistration:resend_invite',
  wrong_data_contact_with_hp = 'bpRegistration:wrong_data_contact_with_hp',
  notification_was_resent = 'bpRegistration:notification_was_resent',
  reg_next_attempt_will_be_availabel_at = 'bpRegistration:reg_next_attempt_will_be_availabel_at',
  reg_attempts_left_before_the_break = 'bpRegistration:reg_attempts_left_before_the_break',
  continue_registration_new_company = 'bpRegistration:continue_registration_new_company',
  company_not_found = 'bpRegistration:company_not_found',
  distributors = 'bpRegistration:distributors',
  distributors_on_behalf = 'bpRegistration:distributors_on_behalf',
  distributor_list_was_updated = 'bpRegistration:distributor_list_was_updated',
  distributors_update = 'bpRegistration:distributors_update',
  apollo_dialog_header = 'bpRegistration:apollo_dialog_header',
  apollo_dialog_table_column_name = 'bpRegistration:apollo_dialog_table_column_name',
  apollo_dialog_table_column_country = 'bpRegistration:apollo_dialog_table_column_country',
  apollo_dialog_table_column_city = 'bpRegistration:apollo_dialog_table_column_city',
  apollo_dialog_table_column_tax_id = 'bpRegistration:apollo_dialog_table_column_tax_id',
  apollo_dialog_table_column_postal_code = 'bpRegistration:apollo_dialog_table_column_postal_code',
  apollo_dialog_table_column_address_line1 = 'bpRegistration:apollo_dialog_table_column_address_line1',
  apollo_dialog_table_column_address_line2 = 'bpRegistration:apollo_dialog_table_column_address_line2',
  apollo_dialog_table_column_address_line3 = 'bpRegistration:apollo_dialog_table_column_address_line3',
  apollo_dialog_table_column_website = 'bpRegistration:apollo_dialog_table_column_website',
  apollo_dialog_cancel_button = 'bpRegistration:apollo_dialog_cancel_button',
  apollo_dialog_submit_user_form_button = 'bpRegistration:apollo_dialog_submit_user_form_button',
  distributors_on_behalf_description = 'bpRegistration:distributors_on_behalf_description',
  apollo_dialog_table_apply_apollo_match = 'bpRegistration:apollo_dialog_table_apply_apollo_match',
  apollo_dialog_explanation_message = 'bpRegistration:apollo_dialog_explanation_message',
  company_trading_name = 'bpRegistration:company_trading_name',
  distributors_on_behalf_previous_selected_values = 'bpRegistration:distributors_on_behalf_previous_selected_values',
  distributors_on_behalf_update_description = 'bpRegistration:distributors_on_behalf_update_description',
  email_used_not_eligile = 'bpRegistration:email_used_not_eligile',
  email_used_not_eligile_use_invite_email = 'bpRegistration:email_used_not_eligile_use_invite_email',
  not_my_company = 'bpRegistration:not_my_company',
  not_my_company_check_info = 'bpRegistration:not_my_company_check_info',
  not_my_company_thank_you = 'bpRegistration:not_my_company_thank_you',
  regards_thank_you = 'bpRegistration:regards_thank_you',
  team_name = 'bpRegistration:team_name',
  update_company_details = 'bpRegistration:update_company_details',
  i_an_general_manager = 'bpRegistration:i_an_general_manager',
  t_and_c_not_access = 'bpRegistration:t_and_c_not_access',
  t_and_c_accepted = 'bpRegistration:t_and_c_accepted',
  distributor_list_wasnt_updated = 'bpRegistration:distributor_list_wasnt_updated',
  distributors_on_behalf_invitation_was_sent = 'bpRegistration:distributors_on_behalf_invitation_was_sent',
  distributors_on_behalf_fail_send_invitation = 'bpRegistration:distributors_on_behalf_fail_send_invitation',
  cont_perm_text_hpa = 'bpRegistration:cont_perm_text_hpa',
}
